module.exports = __webpack_public_path__ + "img/7.d7480d20.jpg";